import React, { Component } from 'react'
import { Field, reduxForm, change } from 'redux-form'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'
import { translate } from 'react-i18next'

// COMPONENTS
import Spinner from '../spinner'
import customInputLine from './field/customInputLine'
import { ButtonContained } from '../app-button/button'
import { required, email } from './validation/validation'

const styles = theme => ({
  form: {
    maxWidth: 360,
    width: '100%',
  },
})

class EmailPassForm extends Component {
  resetValueField = name => {
    this.props.change(this.props.form, name, '')
  }

  render() {
    const { classes, isFetching, handleSubmit, t } = this.props

    return (
      <form onSubmit={handleSubmit} className={classes.form}>
        <div className={classes.inputWrapper}>
          <Field
            name="email"
            component={customInputLine}
            type="text"
            label={t('emailPassReset.email', { framework: 'react-i18next' })}
            validate={[required, email]}
            handleResetField={this.resetValueField}
          />
        </div>
        <ButtonContained
          style={{
            height: 64,
            fontSize: 16,
            width: '100%',
            padding: 0,
            marginBottom: '20px',
            fontWeight: 700,
          }}
          type="submit"
          color="primary"
          text={
            isFetching ? (
              <Spinner stroke="#000000" />
            ) : (
              t('emailPassReset.btn', { framework: 'react-i18next' })
            )
          }
        />
      </form>
    )
  }
}

const mapDispatchToProps = {
  change,
}

EmailPassForm = reduxForm({
  form: 'EmailPassForm',
})(connect(null, mapDispatchToProps)(EmailPassForm))

export default withStyles(styles)(translate('common')(EmailPassForm))
